module.exports = __webpack_public_path__ + "static/media/StripeCard.bbec15a2.png";